import axios from 'axios'

export default class ReconciliationService {
  static async reconcileUsers (userIds) {
    return await axios({
      url: process.env.VUE_APP_INTERNAL_API_BASEURL + '/reconciliation/user/compare',
      method: 'POST',
      headers: { 'Content-Type': 'text/plain', 'Accept': 'text/plain' },
      data: userIds
    }).then(response => response.data)
  }
}
